import { createFileRoute } from '@tanstack/react-router';
import { PlaybookPage } from '@/features/playbook';

export const Route = createFileRoute('/_app/playbook')({
    component: PlaybookPage,
});
